export default "__VITE_ASSET__DUaB$hVy__"